import React, { useEffect, useMemo, useState } from "react";
import {
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";
import { isValidCPF } from "../utils/validate";
import { BasicDetailsTypes } from "../types/profile";

interface DataTypes {
  idCliente: string | null;
  cpf: string | null;
}

interface CustomerModalProps {
  isOpen: boolean;
  chatUserDetails: BasicDetailsTypes;
  onClose: () => void;
  onConfirm: (data: any) => void;
}

const CustomerModal = ({
  isOpen,
  chatUserDetails,
  onClose,
  onConfirm,
}: CustomerModalProps) => {

  /*
  data input handeling
  */
  const [data, setData] = useState<DataTypes>({
    idCliente: chatUserDetails.idCliente ? chatUserDetails.idCliente.toString() : "",
    cpf: chatUserDetails.cpfCnpj ? chatUserDetails.cpfCnpj : "",
  });

  const [idClienteTouched, setIdClienteTouched] = useState(false);
  const idClienteIsValid = useMemo(() => {
    if (!data.idCliente) return false;

    const value = Number(data.idCliente);
    return Number.isInteger(value) && value > 0;
  }, [data.idCliente]);

  const [cpfTouched, setCpfTouched] = useState(false);
  const cpfIsValid = isValidCPF(data.cpf ?? "");

  useEffect(() => {
    setData({
      idCliente: data.idCliente,
      cpf: data.cpf,
    });
  }, []);

  const onChangeData = (field: "idCliente" | "cpf", value: string) => {
    let modifiedData: DataTypes = { ...data };
    if (value === "") {
      modifiedData[field] = null;
    } else {
      modifiedData[field] = value;
    }
    setData(modifiedData);
  };

  /*
  validation
  */
  const [valid, setValid] = useState<boolean>(false);

  useEffect(() => {
    if (idClienteIsValid && cpfIsValid) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [data, idClienteIsValid, cpfIsValid]);


  return (
    <Modal isOpen={isOpen} toggle={onClose} tabIndex={-1} centered scrollable >
      <ModalHeader toggle={onClose} className="bg-primary">
        <div className="modal-title-custom text-white font-size-16 ">
          Novo contato
        </div>
      </ModalHeader>
      <ModalBody className="p-4">
        <Form>

          {/* ID do Cliente */}
          <div className="mb-3">
            <Label htmlFor="AddContactModalidCliente-input" className="form-label">
              ID Cliente
            </Label>
            <Input
              type="text"
              id="AddContactModalidCliente-input"
              placeholder="Identificador"
              value={data.idCliente || ""}
              valid={idClienteTouched && idClienteIsValid}
              invalid={idClienteTouched && !idClienteIsValid}
              onBlur={() => setIdClienteTouched(true)}
              onChange={(e) => {
                // const onlyNumbers = e.target.value.replace(/\D/g, '');
                onChangeData("idCliente", e.target.value);
              }}
            />

            {idClienteTouched && !idClienteIsValid && (
              <div className="invalid-feedback d-block">
                Informe identificador do cliente - Finance (ex: 9999)
              </div>
            )}
          </div>

          {/* CPF do Cliente     */}
          <div className="mb-3">
            <Label htmlFor="AddContactModalCpfCliente-input" className="form-label">
              CPF do Cliente
            </Label>
            <Input
              type="text"
              id="AddContactModalCpfCliente-input"
              placeholder="Identificador"
              value={data.cpf || ""}
              valid={cpfTouched && cpfIsValid}
              invalid={cpfTouched && !cpfIsValid}
              onBlur={() => setCpfTouched(true)}
              onChange={(e) => {
                // const onlyNumbers = e.target.value.replace(/\D/g, '');
                onChangeData("cpf", e.target.value);
              }}
            />

            {cpfTouched && !cpfIsValid && (
              <div className="invalid-feedback d-block">
                Informe CPF do cliente - Finance válido
              </div>
            )}
          </div>

        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="link" className="btn" onClick={onClose}>
          Close
        </Button>
        <Button
          type="button"
          color="primary"
          disabled={!valid}
          onClick={() => onConfirm(data)}
        >
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CustomerModal;
